module.exports = __webpack_public_path__ + "img/huawei_foreign.a3b775fe.png";